// extracted by mini-css-extract-plugin
export default {"container":"NewAdminUser_container__YXPFt","phone__input":"NewAdminUser_phone__input__+7jUS"};